// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function ConversationIcon(props) {
  var __size = props.size;
  var size = __size !== undefined ? __size : 90;
  return JsxRuntime.jsxs("svg", {
              children: [
                JsxRuntime.jsx("path", {
                      d: "M66.41,45.55c-7.33-7.34-17.1-11.38-27.51-11.38c-10.41,0-20.18,4.04-27.52,11.39 C-2.86,59.8-3.82,82.59,8.98,97.96c-1.01,2.05-2.58,4.48-4.81,6.11c-1.52,1.11-2.15,3.06-1.57,4.85c0.58,1.79,2.25,2.99,4.12,2.99 c3.44,0,8.53-0.81,13.73-4.57c5.67,3.05,12,4.65,18.43,4.65c10.41,0,20.19-4.05,27.55-11.41c7.34-7.34,11.39-17.12,11.38-27.52 C77.81,62.67,73.76,52.9,66.41,45.55z M63.36,97.52c-6.67,6.67-15.53,10.14-24.48,10.14c-6,0-12.04-1.56-17.48-4.76 c-0.35-0.21-0.74-0.31-1.13-0.31c-0.58,0-1.15,0.23-1.58,0.66c-0.07,0.03-0.13,0.18-0.18,0.23c-4.47,3.47-8.86,4.29-11.77,4.29H6.72 c3.35-2.89,5.46-6.18,6.7-9c0.2-0.48,0.23-1.02,0.12-1.49c-0.05-0.45-0.23-0.92-0.54-1.28C0.91,82.36,1.54,61.55,14.45,48.64 c6.74-6.74,15.6-10.12,24.45-10.12s17.71,3.37,24.44,10.11C76.85,62.11,76.85,84.03,63.36,97.52z",
                      fill: "currentColor"
                    }),
                JsxRuntime.jsx("circle", {
                      cx: "38.91",
                      cy: "73.07",
                      fill: "currentColor",
                      r: "2.74"
                    }),
                JsxRuntime.jsx("circle", {
                      cx: "53.05",
                      cy: "73.07",
                      fill: "currentColor",
                      r: "2.74"
                    }),
                JsxRuntime.jsx("circle", {
                      cx: "24.78",
                      cy: "73.07",
                      fill: "currentColor",
                      r: "2.74"
                    }),
                JsxRuntime.jsx("g", {
                      children: JsxRuntime.jsx("rect", {
                            height: "4.34",
                            width: "22.05",
                            fill: "currentColor",
                            x: "118.65",
                            y: "21.01"
                          })
                    }),
                JsxRuntime.jsx("g", {
                      children: JsxRuntime.jsx("rect", {
                            height: "4.34",
                            width: "55.85",
                            fill: "currentColor",
                            x: "84.85",
                            y: "32.58"
                          })
                    }),
                JsxRuntime.jsx("g", {
                      children: JsxRuntime.jsx("rect", {
                            height: "4.34",
                            width: "42.66",
                            fill: "currentColor",
                            x: "98.04",
                            y: "44.15"
                          })
                    }),
                JsxRuntime.jsx("path", {
                      d: "M149.8,0H67.29c-5.57,0-10.11,4.54-10.11,10.11V38.7c1.5,0.8,2.95,1.71,4.34,2.71v-31.3 c0-3.18,2.59-5.78,5.78-5.78h82.51c3.18,0,5.78,2.59,5.78,5.78v50.38c0,3.18-2.59,5.78-5.78,5.78h-10.65c-4.31,0-7.81,3.5-7.81,7.81 v5.8l-11.96-11.44c-1.46-1.38-3.37-2.13-5.38-2.13H77.22c0.25,1.43,0.42,2.87,0.51,4.34h36.28c0.92,0,1.76,0.34,2.4,0.95 l19.27,18.43V74.08c0-1.91,1.56-3.47,3.47-3.47h10.65c5.57,0,10.11-4.54,10.11-10.11V10.11C159.92,4.54,155.38,0,149.8,0z",
                      fill: "currentColor"
                    })
              ],
              height: String(size),
              width: String(size),
              viewBox: "0 0 159.92 112",
              x: "0px",
              xmlSpace: "preserve",
              y: "0px"
            });
}

var make = ConversationIcon;

exports.make = make;
/* react/jsx-runtime Not a pure module */
